import { L10n } from "@fidget/common/i18n";
import { logger } from "@fidget/common/utils";
import React, { useEffect, useState } from "react";
import { useAgentServices } from "../../../../../models/agentServices";
import styles from "./pendingStatus.css";

interface Props {
  inviteeEmail: string;
}

export const PendingStatus = (props: Props) => {
  const { spinnerService } = useAgentServices();
  const [timeoutId, setTimeoutId] = useState<number>();
  const [invitationResend, setInvitationResend] = useState(false);

  useEffect(() => {
    return () => {
      clearTimeout(timeoutId);
    };
  }, [timeoutId]);

  const resendInvitation = async () => {
    try {
      await spinnerService.resendInvitation({ email: props.inviteeEmail });
      setInvitationResend(true);
      setTimeoutId(window.setTimeout(() => setInvitationResend(false), 2000));
    } catch (e) {
      logger.error({ message: "Couldn't resend invitation", error: e });
      throw Error("Could not resend invitation");
    }
  };

  const render = () => {
    return (
      <div className={styles["pending-status-container"]}>
        {(invitationResend && (
          <div className={styles["is-resend"]}>
            <i className="icon-ok" />
            <L10n id={"settings.advisers.invitationResend"} />
          </div>
        )) || (
          <>
            <div className={styles.pending}>
              <L10n id={"settings.advisers.pending"} />
            </div>
            <div className={styles.resend} onClick={resendInvitation}>
              <L10n id={"settings.advisers.resendInvitation"} />
            </div>
          </>
        )}
      </div>
    );
  };

  return render();
};
